export default "__VITE_ASSET__CpegD$qa__"